<template>
    <div>
        
        <PreventiveDentistry />
    </div>
</template>

<script>

import PreventiveDentistry from '../blog-details/PreventiveDentistry.vue'

export default {
    components: {
       
        PreventiveDentistry,
    }
}
</script>